import { useState, useCallback, useMemo } from "react";

type Callback = () => void;
export function useForceRerender(): [rerender: Callback, version: number] {
	const [version, setVersion] = useState<number>(0);

	const callback: Callback = useCallback(
		(): void => setVersion(x => x + 1),
		[]
	);

	return useMemo(
		(): [Callback, number] => [
			callback,
			version
		],
		[version, callback]
	);
}
